import { AdgroupFormData } from '@tt4b/ttam-enums';
import { computed, Ref } from '@vue/composition-api';
import { i18n } from './../../../i18n';
import { difference } from 'lodash-es';

export function usePropsModalTitle(opt: { label: Ref<string>; batchFormData: Ref<Partial<AdgroupFormData>[]> }) {
  const modalTitle = computed(() =>
    i18n.t('adcopier_editor_title', { label: opt.label.value, n: opt.batchFormData.value.length })
  );
  return {
    modalTitle,
  };
}

export function usePropsEditorEnable(opt: {
  fields: Ref<(keyof AdgroupFormData)[]>;
  adgroupData: Ref<AdgroupFormData>;
}) {
  const isEditorEnable = computed(() => difference(opt.fields.value, Object.keys(opt.adgroupData.value)).length === 0);
  return {
    isEditorEnable,
  };
}
